import styles from "./index.module.less";
import Icon from "@/components/Icon";
import QRCode from "@/assets/img/web2x_pic_erweima.png";
import footerImg from "@/assets/img/foot_logo.png";
const Footer = () => {
  return (
    <div className={styles["footer-view"]}>
      <div className="first">
        <div className="line-box" />

        <div className="footer-icon">
          <Icon icon="Group39" style={{ fontSize: "32px" }} />
          <Icon icon="Group40" style={{ fontSize: "32px" }} />
          <Icon icon="Group41" style={{ fontSize: "32px" }} />
          <Icon icon="Group42" style={{ fontSize: "32px" }} />
        </div>

        <div className="footer-logo">
          <img data-v-16d0b352="" src={footerImg} alt="logo" />
        </div>

        <div className="footer-text phone">热线电话：028-87526280</div>

        <div className="footer-text email">
          赛事邮箱：UCCMarketing@wolterskluwer.com
        </div>

        <div className="qrCode">
          <img src={QRCode} alt="logo" />
          <div className="qrCode-text">
            关注UpToDate临床顾问速递微信平台获取更多大赛相关信息
          </div>
        </div>
      </div>

      <div className="second">
        <div>京 ICP 证 110182 号 | (京)-经营性-2015-0003</div>
        <div>© UpToDate, Inc. and/or its affiliates. All rights reserved.</div>
      </div>
    </div>
  );
};

export default Footer;
